import styled from "styled-components"
import { motion } from "framer-motion"

export const StyledSendMessageBox = styled(motion.div)`
  position: absolute;
  bottom: -50px;
  display: flex;
  justify-content: center;
`
